// root '../../../';

// dependencies
import { Child } from 'pym.js';
import Zion from './utils/Zion';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';
// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)


// styles
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

const d3 = require('d3');

const mapboxgl = require('mapbox-gl');
const MapboxGeocoder = require('@mapbox/mapbox-gl-geocoder');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ id: pkg.name });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

mapboxgl.accessToken = 'pk.eyJ1IjoiY25uZGlnaXRhbCIsImEiOiJja2V1M3Vyd3kwMDZrMnF0Njdhb3ZhZDk5In0.OURIYzTcS6ZzoWjXJzfANg';

const isMobile = window.innerWidth < 500;

// Parse query parameters
const urlParams = new URLSearchParams(window.location.search);
const region = urlParams.get('region');

// Region presets for different map focuses
const regionPresets = {
  west: {
    center: ['-117', '40'],
    zoom: isMobile ? 3.5 : 4.5,
  },
  east: {
    center: ['-78', '38'],
    zoom: isMobile ? 3.5 : 4.5,
  },
  default: {
    center: ['-98.5', '39.8'],
    zoom: isMobile ? 2.5 : 3.5,
  },
};

const activeRegion = regionPresets[region] || regionPresets.default;
const startLocation = activeRegion.center;
const startZoom = activeRegion.zoom;

const forecastMap = new mapboxgl.Map({
  container: 'snow-forecast-map',
  // style: 'mapbox://styles/cnndigital/cl960ytee001215qu1uhorjlx',
  style: 'mapbox://styles/cnndigital/cllwui6vg00fz01qu0xl0cbu2',
  center: [startLocation[0], startLocation[1]],
  zoom: startZoom,
  minZoom: 3,
  maxZoom: 6,
  bearing: 0,
  scrollZoom: false,
  dragRotate: false,
  touchPitch: false,
  interactive: true,
  projection: 'albers',

});
forecastMap.addControl(new mapboxgl.NavigationControl({
  showCompass: false,
}), 'top-right');

// forecastMap.addControl(new MapboxGeocoder({
//   accessToken: mapboxgl.accessToken,
//   mapboxgl,
//   marker: false,
//   flyTo: {
//     curve: 1,
//   },
// }), 'bottom-left');

forecastMap.on('load', () => {
  const firstLayer = forecastMap.getStyle().layers[7];

  forecastMap.addSource('snow1', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxsnowfore1',
  });
  forecastMap.addSource('snow2', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxsnowfore2',
  });

  forecastMap.addSource('snow3', {
    type: 'raster',
    url: 'mapbox://cnndigital.wxsnowfore3',
  });

  forecastMap.addLayer({
    id: 'snow1',
    type: 'raster',
    source: 'snow1',
    layout: { visibility: 'visible' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);

  forecastMap.addLayer({
    id: 'snow2',
    type: 'raster',
    source: 'snow2',
    layout: { visibility: 'none' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);

  forecastMap.addLayer({
    id: 'snow3',
    type: 'raster',
    source: 'snow3',
    layout: { visibility: 'none' },
    paint: {
      'raster-fade-duration': 0,
      'raster-opacity': 1,
    },
  },
  firstLayer.id);
  pymChild.sendHeight();
});
const forecastButtons = document.querySelectorAll('.forecast.button');

const updateForecast = (event) => {
  const t = event.target.dataset.layer;
  for (const layer of ['snow1', 'snow2', 'snow3']) {
    forecastMap.setLayoutProperty(layer, 'visibility', 'none');
  }
  for (const b of forecastButtons) {
    b.classList.remove('active');
  }
  forecastMap.setLayoutProperty(t, 'visibility', 'visible');
  event.target.classList.add('active');
};

for (const button of forecastButtons) {
  button.addEventListener('click', updateForecast);
}


d3.timeFormatDefaultLocale({
  periods: ['a.m.', 'p.m.'],
  days: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  shortDays: ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'],
  months: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  shortMonths: [
    'Jan.',
    'Feb.',
    'March',
    'April',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.',
  ],
});

d3.json('https://ix.cnn.io/data/wx-snow-forecast/forecast-date.json').then((data) => {
  const updateTime = d3.timeParse('%Y-%m-%dT%H:%M:%S%Z')(`${data.timestamp}Z`);

  d3.select('#forecast-map-timestamp')
    .text(`Forecast updated ${d3.timeFormat('%-I:%M %p on %b %-d, %Y')(updateTime)}`);
});
